// generated by wasm-url-literal plugin
const url = new URL("./resources/c2pa_bg.wasm", import.meta.url).toString();
export default url;
